import React from "react";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

function SidebarLink(props) {
  return (
    <Link className="link-item" to={props.route}>
      <Button>
        <p>{props.text}</p>
      </Button>
    </Link>
  );
}

export default SidebarLink;
